module.exports = __webpack_public_path__ + "img/article1.6b61b222.jpg";